<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Points"
    :show-banner="false"
    :show-sponsors="false"
  >
    <!-- Points Overview Section -->
    <div class="points-overview-section">
      <div class="points-cards-container">
        <div class="points-card-mini single-card">
          <div class="mini-icon" :class="detailUser.community && detailUser.community.community === 'Bert Influencer' ? 'blue' : 'orange'">
            <img 
              :src="detailUser.community && detailUser.community.community === 'Bert Influencer' ? require('@/assets/berts-point-award.svg') : require('@/assets/berts-point-reward.svg')" 
              :alt="detailUser.community && detailUser.community.community === 'Bert Influencer' ? 'Award Points' : 'Reward Points'" 
            />
          </div>
          <div class="mini-content">
            <div class="mini-number">{{ userPoints.reward_points || 0 }}</div>
            <div class="mini-label">
              {{ detailUser.community && detailUser.community.community === 'Bert Influencer' ? 'Award Points' : 'Reward Points' }}
            </div>
          </div>
        </div>
      </div>

      <div class="points-footer-actions">
        <bert-button 
          variant="primary" 
          size="sm" 
          @click="goToRewardAdd"
          class="footer-action-btn"
        >
          Tambah Poin +
        </bert-button>
        <bert-button 
          variant="ghost" 
          size="sm" 
          @click="goToRewardDetail"
          class="footer-action-btn detail"
        >
          Detail Poin →
        </bert-button>
      </div>
    </div>

    <!-- Points Actions Section -->
    <div class="points-actions-section">
      <div class="action-tabs">
        <bert-button 
          variant="outline"
          size="md"
          :class="{ 'active': activeTab === 'redeem' }"
          @click="setActiveTab('redeem')"
          class="action-tab-btn"
        >
          {{ detailUser.community && detailUser.community.community === 'Bert Influencer' ? 'Redeem Award Point' : 'Redeem Reward Point' }}
        </bert-button>

        <bert-button 
          variant="outline"
          size="md"
          @click="riwayat"
          class="action-tab-btn"
        >
           Riwayat Redeem
        </bert-button>
      </div>
    </div>

    <!-- Redeem Section -->
    <div v-if="activeTab === 'redeem'" class="redeem-section">
      <!-- Exchange Availability Notice -->
      <div v-if="!isExchangeAvailable" class="exchange-notice">
        <div class="notice-content">
          <i class="mdi mdi-information notice-icon"></i>
          <div class="notice-text">
            <h4>Penukaran Tidak Tersedia Hari Ini</h4>
            <p>Penukaran produk hanya tersedia pada hari: <strong>{{ exchangeDaysText }}</strong></p>
            <p class="notice-hint">Kamu masih bisa melihat produk yang tersedia di bawah ini.</p>
          </div>
        </div>
      </div>

      <div class="section-header">
        <h3 class="section-title">Klaim Hadiah</h3>
        <p class="section-subtitle">Tukar poinmu dengan produk atau voucher di bawah ini!</p>
      </div>
          
          <div v-if="redeemProducts.length === 0" class="empty-state">
            <div class="empty-icon">
              <i class="mdi mdi-gift-outline"></i>
            </div>
            <h3 class="empty-title">Belum Ada Produk</h3>
            <p class="empty-description">Produk redeem akan segera tersedia. Pantau terus halaman ini!</p>
          </div>

          <div v-else class="products-grid">
            <div v-for="(product, index) in redeemProducts" :key="index" class="product-card">
              <div class="product-image">
                <img 
                  :src="getProductImage(product)" 
                  :alt="product.nama" 
                  class="product-photo"
                  @error="handleImageError"
                />
                <div class="product-badge">
                  <span class="badge-text">{{ product.point }} Poin</span>
                </div>
              </div>
              
              <div class="product-content">
                <h4 class="product-title">{{ product.nama }}</h4>
                
                <div class="product-meta">
                  <div class="product-stock">
                    <i class="mdi mdi-package-variant"></i>
                    <span>{{ product.stok }} Stok</span>
                  </div>
                  <div class="product-points">
                    <i class="mdi mdi-star"></i>
                    <span>{{ product.point }} Poin</span>
                  </div>
                </div>
              </div>
              
              <div class="product-actions">
                <bert-button 
                  variant="primary"
                  size="md"
                  :disabled="!isExchangeAvailable || userPoints.reward_points < product.point || product.stok <= 0 || !product.aktif"
                  @click="exchangeProduct(product)"
                  full-width
                  class="exchange-btn"
                >
                  <span v-if="!isExchangeAvailable">Tidak Tersedia Hari Ini</span>
                  <span v-else-if="!product.aktif">Tidak Tersedia</span>
                  <span v-else-if="product.stok <= 0">Stok Habis</span>
                  <span v-else-if="userPoints.reward_points < product.point">Poin Tidak Cukup</span>
                  <span v-else>Exchange Points</span>
                </bert-button>
              </div>
            </div>
          </div>
        </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';
import BertButton from '@/components/ui/Button.vue';

export default {
  name: "NewPoints",
  components: { 
    PageLayout: AppPageLayout,
    'bert-button': BertButton
  },
  data() {
    return {
      isLoading: false,
      userPoints: {
        award_points: 0, // Always 0 - feature coming soon
        reward_points: 0,
        total_points: 0
      },
      redeemProducts: [],
      activeTab: 'redeem',
      detailUser: {},
      setting: {},
      todayName: ''
    };
  },
  computed: {
    isExchangeAvailable() {
      if (!this.setting.hari_redeem && !this.setting.hari_redeem2) {
        return false;
      }
      return this.setting.hari_redeem === this.todayName || 
             this.setting.hari_redeem2 === this.todayName;
    },
    
    exchangeDaysText() {
      const days = [];
      if (this.setting.hari_redeem) days.push(this.setting.hari_redeem);
      if (this.setting.hari_redeem2) days.push(this.setting.hari_redeem2);
      return days.join(' dan ') || 'Belum ditentukan';
    }
  },
  methods: {
    loadUserPoints() {
      const userDatas = this.$getUserInfo();
      const userId = userDatas.sub.user_id;
      const baseURI = this.$settings.endPoint + "pengguna/detail/" + userId;
      this.isLoading = true;
      
      return this.$http
        .get(baseURI, { 
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          const userData = response.data.datas;
          
          // Map the points data based on Home.vue structure
          this.userPoints = {
            award_points: 0, // Always 0 - feature coming soon
            reward_points: userData.point || 0, // Changed from reward_points to reward_points
            total_points: userData.point || 0
          };
        })
        .catch(error => {
          this.isLoading = false;
          console.log('Error loading user points:', error);
          this.handleError(error);
        });
    },
    
    loadRedeemProducts() {
      const baseURI = this.$settings.endPoint + "master-produk/get-produk";
      
      return this.$http
        .get(baseURI, { 
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.redeemProducts = (response.data.datas || []);
        })
        .catch(error => {
          console.log('Error loading redeem products:', error);
          this.handleError(error);
        });
    },
    
    loadSetting() {
      const baseURI = this.$settings.endPoint + "setting/detail/1";
      
      return this.$http
        .get(baseURI, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.setting = response.data.datas || {};
          // Get current day name
          const today = new Date();
          const options = { weekday: 'long' };
          this.todayName = today.toLocaleDateString('en-US', options);
        })
        .catch(error => {
          console.log('Error loading setting:', error);
          this.handleError(error);
        });
    },
    
    setActiveTab(tab) {
      this.activeTab = tab;
    },

    riwayat() {
        this.$router.push("/user/redeem-history");
    },
    
    exchangeProduct(product) {
      if (!this.isExchangeAvailable) {
        this.$swal({
          title: 'Penukaran Tidak Tersedia',
          html: `
            <div style="text-align: center; padding: 20px;">
              <div style="font-size: 3rem; margin-bottom: 16px;">📅</div>
              <p style="margin-bottom: 16px;">Penukaran produk hanya tersedia pada hari:</p>
              <p style="font-weight: bold; color: #F2994A; font-size: 1.1rem; margin-bottom: 16px;">${this.exchangeDaysText}</p>
              <p style="color: #6B7280; font-size: 0.9rem;">Silakan kembali lagi pada hari yang telah ditentukan.</p>
            </div>
          `,
          icon: 'info',
          confirmButtonText: 'Mengerti',
          confirmButtonColor: '#F2994A'
        });
        return;
      }
      
      if (!product.aktif) {
        this.$swal({
          title: 'Produk Tidak Tersedia',
          text: 'Maaf, produk ini sedang tidak tersedia.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
      
      if (this.userPoints.reward_points < product.point) {
        this.$swal({
          title: 'Poin Tidak Cukup',
          text: `Kamu membutuhkan ${product.point} poin untuk menukar produk ini. Poin kamu saat ini: ${this.userPoints.reward_points}`,
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
      
      if (product.stok <= 0) {
        this.$swal({
          title: 'Stok Habis',
          text: 'Maaf, produk ini sedang tidak tersedia.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
      
      // Show confirmation dialog
      this.$swal({
        title: 'Konfirmasi Penukaran',
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <p><strong>Produk:</strong> ${product.nama}</p>
            <p><strong>Poin yang dibutuhkan:</strong> ${product.point}</p>
            <p><strong>Poin kamu saat ini:</strong> ${this.userPoints.reward_points}</p>
            <p><strong>Sisa poin setelah penukaran:</strong> ${this.userPoints.reward_points - product.point}</p>
          </div>
          <p>Apakah kamu yakin ingin melanjutkan penukaran ini?</p>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ya, Tukar!',
        cancelButtonText: 'Batal',
        confirmButtonColor: '#F2994A',
        cancelButtonColor: '#6B7280'
      }).then((result) => {
        if (result.isConfirmed) {
          this.processExchange(product);
        }
      });
    },
    
    processExchange(product) {
      // Show loading state
      this.$swal({
        title: 'Memproses Penukaran...',
        text: 'Mohon tunggu sebentar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      
      // Redirect to new redeem page with product info
      setTimeout(() => {
        this.$swal.close();
        this.$router.push({
          path: '/user/redeem-produk',
          query: { 
            product_id: product.id,
            product_name: product.nama,
            product_points: product.point
          }
        });
      }, 1500);
    },
    
    loadMoreProducts() {
      this.$router.push('/user/redeem-produk');
    },
    
    refreshPoints() {
      this.loadUserPoints();
    },
    
    getProductImage(product) {
      if (product.image && product.image.trim() !== '') {
        return product.image;
      }
      return require('@/assets/cta-background.png');
    },
    
    handleImageError(event) {
      event.target.src = require('@/assets/cta-background.png');
    },
    
    showComingSoonModal() {
      this.$swal({
        title: 'Segera Hadir!',
        html: `
          <div style="text-align: center; padding: 20px;">
            <div style="font-size: 4rem; color: #F59E0B; margin-bottom: 20px;">
              🚀
            </div>
            <h3 style="color: #1F2937; margin-bottom: 16px;">Fitur Award Point</h3>
            <p style="color: #6B7280; line-height: 1.6; margin-bottom: 20px;">
              Fitur Award Point sedang dalam pengembangan dan akan segera tersedia untuk memberikan pengalaman yang lebih baik.
            </p>
            <div style="background: #FEF3C7; padding: 12px; border-radius: 8px; margin-top: 16px;">
              <p style="color: #92400E; font-size: 0.9rem; margin: 0;">
                <strong>💡 Tips:</strong> Pantau terus update terbaru dari kami!
              </p>
            </div>
          </div>
        `,
        icon: null,
        confirmButtonText: 'Mengerti',
        confirmButtonColor: '#F2994A',
        customClass: {
          popup: 'coming-soon-modal'
        }
      });
    },
    
    goToRewardAdd() {
      this.$router.push('/user/reward/add');
    },
    
    goToRewardDetail() {
      this.$router.push('/user/reward');
    },
    
    fetchUserData() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
    },
    
    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          console.error('Validation error:', error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      }
    },
  },
  mounted() {
    this.fetchUserData();
    this.loadUserPoints();
    this.loadRedeemProducts();
    this.loadSetting();
  },
  
  activated() {
    // Refresh points when component becomes active (useful for keep-alive)
    this.refreshPoints();
  }
};
</script>

<style scoped>
/* ========================================= */
/* POINTS OVERVIEW SECTION (FIGMA STYLE)     */
/* ========================================= */
.points-overview-section {
  padding: 24px;
  margin: 0 auto 32px auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  max-width: 1200px;
  width: calc(100% - 64px);
}

.points-cards-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: 24px;
}

.points-card-mini {
  display: flex;
  align-items: center;
  padding: 20px 32px;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  background: white;
  position: relative;
}

.points-card-mini.single-card {
  width: 100%;
  justify-content: center;
}

/* Specific Border Rounding to separate the two boxes visually if needed */
.points-card-mini:first-child {
  margin-right: 0; /* Removed margin since we only have one card */
}

.mini-icon {
  width: 56px;
  height: 56px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mini-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.mini-content {
  display: flex;
  flex-direction: column;
}

.mini-number {
  font-size: 28px;
  font-weight: 800;
  color: #333C4E;
  line-height: 1.1;
}

.mini-label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
  margin-top: 4px;
}

.points-footer-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.footer-action-btn {
  flex: 1;
}

.footer-action-btn.detail {
  color: var(--yellow-main) !important;
}

/* Footer Actions Section */
.points-footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
}

.tambah-poin-btn {
  background: #F2994A;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.tambah-poin-btn:hover {
  background: #e0874a;
  transform: translateY(-1px);
}

.detail-poin-link {
  color: #F2994A;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.detail-poin-link:hover {
  text-decoration: underline;
}

/* ========================================= */
/* POINTS ACTIONS TABS                       */
/* ========================================= */
.points-actions-section {
  padding: 0 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.action-tabs {
  display: flex;
  gap: 12px;
  background: white;
  border-radius: 12px;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.action-tab-btn {
  flex: 1;
}

.action-tab-btn.active {
  background: var(--yellow-main) !important;
  color: white !important;
  border-color: var(--yellow-main) !important;
}

/* ========================================= */
/* REDEEM PRODUCTS SECTION                    */
/* ========================================= */
.redeem-section {
  padding: 0 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

/* Exchange Notice */
.exchange-notice {
  background: #FEF3C7;
  border: 1px solid #F59E0B;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 32px;
}

.notice-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.notice-icon {
  font-size: 1.5rem;
  color: #F59E0B;
  margin-top: 2px;
}

.notice-text h4 {
  color: #92400E;
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 700;
}

.notice-text p {
  color: #92400E;
  margin: 0 0 8px 0;
  line-height: 1.5;
}

.notice-text p:last-child {
  margin-bottom: 0;
}

.notice-hint {
  font-size: 0.9rem;
  opacity: 0.8;
}

.section-header {
  text-align: center;
  margin-bottom: 32px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.section-subtitle {
  color: #6B7280;
  margin: 0;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
  align-items: stretch;
}

.product-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-card:hover {
  transform: translateY(-4px);
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.product-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #4A90E2;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.product-content {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.product-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: auto;
}

.product-stock, .product-points {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #6B7280;
}

.exchange-btn {
  width: 100%;
}

.exchange-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.product-actions {
  padding: 0 20px 20px 20px;
  margin-top: auto;
}

/* ========================================= */
/* CLAIM SECTION & EMPTY STATES               */
/* ========================================= */
.empty-state, .coming-soon {
  background: white;
  border-radius: 16px;
  padding: 48px 24px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.empty-icon, .coming-soon-icon {
  width: 80px;
  height: 80px;
  background: #F3F4F6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  font-size: 2.5rem;
  color: #9CA3AF;
}

.coming-soon-icon {
  background: #FEF3C7;
  color: #F59E0B;
}

.coming-soon-action {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.coming-soon-btn {
  max-width: 400px;
  width: 100%;
  padding: 20px !important;
}

.coming-soon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.coming-soon-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.coming-soon-subtitle {
  font-size: 0.9rem;
  opacity: 0.8;
}

.load-more-btn {
  min-width: 200px;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .points-overview-section,
  .points-actions-section,
  .redeem-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 16px;
  }
  
  .exchange-notice {
    margin-bottom: 24px;
  }
  
  .notice-content {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  
  .points-cards-container {
    flex-direction: column;
    gap: 12px;
  }
  
  .points-card-mini.single-card {
    width: 100%;
    max-width: none;
    margin-right: 0 !important;
  }
  
  .points-footer-actions {
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
  }

  .mini-number {
    font-size: 22px;
  }
  
  .products-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .product-image {
    height: 160px;
  }
  
  .product-content {
    padding: 16px;
  }
  
  .product-actions {
    padding: 0 16px 16px 16px;
  }
  
  .coming-soon-btn {
    padding: 16px !important;
    max-width: 100%;
  }
  
  .coming-soon-title {
    font-size: 1rem;
  }
  
  .coming-soon-subtitle {
    font-size: 0.85rem;
  }
  
  .footer-action-btn {
    font-size: 0.9rem;
  }
  
  .action-tab-btn {
    font-size: 0.9rem;
  }
}

/* ========================================= */
/* GLOBAL OVERRIDES FOR MODALS               */
/* ========================================= */
:global(.coming-soon-modal) {
  border-radius: 16px !important;
}
</style>